import { render, staticRenderFns } from "./VesselMapLayer.vue?vue&type=template&id=3a39f7d5&"
import script from "./VesselMapLayer.vue?vue&type=script&lang=js&"
export * from "./VesselMapLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports